/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

/**
 * Back arrow that points toward the visual start edge (back navigation).
 * LTR uses ←; RTL uses → so the arrow matches reading direction.
 */
export default function DirectionalBackIcon(props) {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';
  const Icon = isRtl ? ArrowForwardIcon : ArrowBackIcon;
  return <Icon {...props} />;
}
